/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_S5_Li1Inputs */

const en_guide_json_vs_yaml_xml_s5_li1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S5_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use <strong>JSON</strong> for: REST APIs, web applications, data interchange between services, NoSQL databases`)
};

const ko_guide_json_vs_yaml_xml_s5_li1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S5_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>JSON</strong> 사용: REST API, 웹 애플리케이션, 서비스 간 데이터 교환, NoSQL 데이터베이스`)
};

const ja_guide_json_vs_yaml_xml_s5_li1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S5_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>JSON</strong>の使用場面：REST API、Webアプリケーション、サービス間のデータ交換、NoSQLデータベース`)
};

/**
* | output |
* | --- |
* | "Use <strong>JSON</strong> for: REST APIs, web applications, data interchange between services, NoSQL databases" |
*
* @param {Guide_Json_Vs_Yaml_Xml_S5_Li1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_s5_li1 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_S5_Li1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_S5_Li1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_s5_li1(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_s5_li1(inputs)
	return ja_guide_json_vs_yaml_xml_s5_li1(inputs)
});